import { render } from "./vfileclassify.vue?vue&type=template&id=0ecaa4b4&scoped=true"
import script from "./vfileclassify.vue?vue&type=script&lang=js"
export * from "./vfileclassify.vue?vue&type=script&lang=js"

import "./vfileclassify.vue?vue&type=style&index=0&id=0ecaa4b4&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境总后台manage.jsyinba.com/jsgeneral/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ecaa4b4"]])

export default __exports__